import React from "react";
import { Link } from "react-router-dom";
// Elements
import ContactInfoCard from "../../elements/contact-info-card";
import ContactUsBanner from "./ContactUsBanner";
import ContactUsForm from "./ContactUsForm";

const ContactUs = ({ t }) => {
  return (
    <div className="page-content">
      <ContactUsBanner t={t} />
      <div className="breadcrumb-row">
        <div className="container">
          <ul className="list-inline">
            <li>
              <Link to="/">{t("header.home")}</Link>
            </li>
            <li>{t("contact.us")}</li>
          </ul>
        </div>
      </div>

      <div className="content-block">
        <div className="page-banner contact-page section-sp1">
          <div className="container">
            <div className="row">
              <div className="col-lg-7 col-md-7 m-b30">
                <div className="ajax-message"></div>
                <div className="heading-bx left">
                  <p>{t("contact.help")}</p>
                  <br />
                  <h3 className="title-head">
                    {t("contact.leave")} <span>{t("contact.yourMessage")}</span>
                  </h3>
                </div>
                <ContactUsForm t={t} />
              </div>
              <div className="col-lg-5 col-md-5 m-b30">
                <ContactInfoCard t={t} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
